import React from 'react';
import styled from 'styled-components';

const CustomIFrame = styled.iframe<{ cssHeight: string; clickable: boolean }>`
  border: none;
  height: ${(props) => props.cssHeight};
  pointer-events: ${(props) => (props.clickable ? 'auto' : 'none')};
`;

interface Props {
  src: string | undefined;
  scale: number;
  clickable: boolean;
}

const EmailPreviewIframe = (props: Props): JSX.Element => {
  const [height, setHeight] = React.useState('100%');
  const ref = React.useRef<HTMLIFrameElement>(null);
  const scale = props.scale;

  const onLoad = () => {
    if (ref.current) {
      setHeight(
        (ref.current.contentWindow?.document.body.scrollHeight ?? 0) * scale +
          'px'
      );
    }
  };

  return (
    <CustomIFrame
      ref={ref}
      onLoad={onLoad}
      title="preview"
      clickable={props.clickable}
      cssHeight={height}
      style={{
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        width: '100%'
      }}
      srcDoc={props.src
        ?.replace(
          '<html ',
          `<html style=";transform-origin: top left;transform: scale(${scale.toString()}); height: 100%;" `
        )
        .replace(
          '<body class="body" style="',
          `<body class="body" style="width: ${(100 / scale).toString()}%;`
        )
        .replace(
          '<body style="',
          `<body style="width: ${(100 / scale).toString()}%;`
        )}
    />
  );
};

export default EmailPreviewIframe;
